import type { ParcelTerminal } from '@/domain/Parcel';
import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export interface ParcelTerminalsListResponse {
  data: Array<ParcelTerminal>;
}

export const parcelTerminalsListQuery = (countryCode?: string) =>
  queryOptions({
    queryKey: queryKeys.parcels.listTerminals(countryCode),
    queryFn: async () =>
      api
        .get('parcels/terminals', {
          searchParams: { country_code: countryCode },
        })
        .json<ParcelTerminalsListResponse>(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });

export const fetchParcelSticker = (orderId: number): Promise<Blob> =>
  api.get(`parcels/sticker/${orderId}`).blob();
